import Head from 'next/head'
import Nav from './Nav'
import stylesheet from 'antd/dist/antd.min.css'

export default ({ children, nav = [], title = 'ETALKING', type, data }) => (
  <div>
    <Head>
      <title>{ title }</title>
      <meta charSet='utf-8' />
      <meta name="viewport" content="width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no" />
      { data && data.headSrc && <script async src={data.headSrc}></script> }
      { data && data.injectJSinHead && data.injectJSinHead.map((item, idx) => {
        return <script key={idx} dangerouslySetInnerHTML={{ __html: item }} />
      }) }
      <script type="text/javascript" src="https://www.googleadservices.com/pagead/conversion_async.js" charSet="utf-8"></script>
      <script type="text/javascript" src="https://www.google-analytics.com/analytics.js" async></script>
      <script type="text/javascript" src="../static/vbtrax.js"></script>
    </Head>
    <Nav nav={nav} type={type} />
    { children }
    <style dangerouslySetInnerHTML={{ __html: stylesheet }} />
    <style jsx global>{`
      /* http://meyerweb.com/eric/tools/css/reset/ 
        v2.0 | 20110126
        License: none (public domain)
      */

      html, body, div, span, applet, object, iframe,
      h1, h2, h3, h4, h5, h6, p, blockquote, pre,
      a, abbr, acronym, address, big, cite, code,
      del, dfn, em, img, ins, kbd, q, s, samp,
      small, strike, strong, sub, sup, tt, var,
      b, u, i, center,
      dl, dt, dd, ol, ul, li,
      fieldset, form, label, legend,
      table, caption, tbody, tfoot, thead, tr, th, td,
      article, aside, canvas, details, embed, 
      figure, figcaption, footer, header, hgroup, 
      menu, nav, output, ruby, section, summary,
      time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
      }
      /* HTML5 display-role reset for older browsers */
      article, aside, details, figcaption, figure, 
      footer, header, hgroup, menu, nav, section {
        display: block;
      }
      body {
        line-height: 1;
      }
      ol, ul {
        list-style: none;
      }
      blockquote, q {
        quotes: none;
      }
      blockquote:before, blockquote:after,
      q:before, q:after {
        content: '';
        content: none;
      }
      table {
        border-collapse: collapse;
        border-spacing: 0;
      }
      html,
      body {
        height: 100%;
        width: 100%;
      }

      body {
        font-family: 'Microsoft JhengHei', '微軟正黑體', 'Noto Sans TC', Arial !important;
      }

      body.fontLoaded {
        font-family: 'Microsoft JhengHei', '微軟正黑體', 'Noto Sans TC', Arial !important;
      }
    `}</style>
    <style jsx>{`
      h1, a {
        font-family: "Arial";
      }

      ul {
        padding: 0;
      }

      li {
        list-style: none;
        margin: 5px 0;
      }

      a {
        text-decoration: none;
        color: blue;
      }

      a:hover {
        opacity: 0.6;
      }
    `}</style>
    { data && data.script_body && <script dangerouslySetInnerHTML={{ __html: data.script_body }} /> }
    { data && data.script_google && <script dangerouslySetInnerHTML={{ __html: data.script_google }} /> }
  </div>
)
